<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col" data-tour="afu-intro">
                <h3 class="page-title">
                  Auto Follow Up
                  <!-- <span
                    class="afu-beta-inline"
                    title="Fitur masih dalam tahap Beta"
                  >BETA</span> -->
                </h3>
                <p class="text-muted mb-2">
                  Buat dan kelola alur follow-up otomatis untuk pelanggan.
                </p>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Auto Follow Up</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto afu-header-action">
                <router-link
                  to="/auto-follow-up/templates"
                  class="btn btn-outline-secondary btn-rounded mr-2 afu-template-btn"
                >
                  <i class="fa fa-copy"></i>
                  Template
                </router-link>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-rounded mr-2 afu-tour-btn"
                  @click="startTour"
                >
                  <i class="fa fa-compass"></i>
                  Panduan Fitur
                </button>
                <router-link
                  :to="createRoute"
                  class="btn add-btn btn-rounded afu-primary-btn"
                  data-tour="afu-create"
                >
                  <i class="fa fa-plus"></i>
                  Buat Alur Follow Up
                </router-link>
              </div>
            </div>
          </div>

          <!-- <div
            v-if="showBetaBanner"
            class="afu-beta-banner"
            role="status"
            aria-live="polite"
            data-tour="afu-beta-banner"
          >
            <div class="afu-beta-banner-icon" aria-hidden="true">
              <i class="fa fa-info-circle"></i>
            </div>
            <div class="afu-beta-banner-content">
              <div class="afu-beta-banner-title">
                <span class="afu-beta-badge">BETA</span>
                Auto Follow Up masih dalam tahap Beta
              </div>
              <p class="mb-1">
                Fitur ini masih diuji dan disempurnakan. Coba dulu dengan
                sejumlah kecil kontak, lalu periksa hasil pengirimannya sebelum
                memakai untuk audiens yang lebih besar.
              </p>
              <p class="mb-0">
                Periksa jadwal, nomor pengirim, dan isi pesan sebelum
                mengaktifkan alur.
              </p>
            </div>
            <button
              type="button"
              class="afu-beta-banner-close"
              aria-label="Tutup informasi Beta"
              title="Tutup informasi Beta"
              @click="dismissBetaBanner"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div> -->

          <div class="row">
            <div
              class="col-xl-3 col-sm-6"
              v-for="card in statCards"
              :key="card.key"
            >
              <div class="card afu-stat-card" :title="card.hint || ''">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span class="afu-stat-icon" :class="card.tone">
                      <i :class="card.icon"></i>
                    </span>
                    <div class="ml-3">
                      <div class="afu-stat-label">{{ card.label }}</div>
                      <div class="afu-stat-value">
                        <Skeleton
                          v-if="statsLoading"
                          width="50px"
                          :count="1"
                        />
                        <template v-else>{{ statsValue(card.key) }}</template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="statsError"
            class="alert alert-warning d-flex align-items-center justify-content-between flex-wrap afu-alert"
          >
            <span>
              <i class="fa fa-exclamation-triangle"></i>
              Ringkasan alur belum dapat dimuat.
            </span>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              :disabled="statsLoading"
              @click="loadStats"
            >
              Coba Lagi
            </button>
          </div>

          <div class="card afu-filter-card" data-tour="afu-list-tools">
            <div class="card-body">
              <div class="row align-items-end">
                <div class="col-lg-5 col-md-6 mb-2 mb-lg-0">
                  <label class="afu-filter-label">Cari alur</label>
                  <input
                    v-model="filters.search"
                    type="text"
                    class="form-control"
                    placeholder="Nama alur..."
                    :disabled="loading"
                    @keyup.enter="applyFilters"
                  />
                </div>
                <div class="col-lg-3 col-md-6 mb-2 mb-lg-0">
                  <label class="afu-filter-label">Status</label>
                  <select
                    v-model="filters.status"
                    class="form-control"
                    :disabled="loading"
                    @change="applyFilters"
                  >
                    <option
                      v-for="option in statusOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-4 col-md-12 d-flex">
                  <button
                    type="button"
                    class="btn afu-primary-btn mr-2"
                    :disabled="loading"
                    @click="applyFilters"
                  >
                    <i
                      :class="loading ? 'fa fa-spinner fa-spin' : 'fa fa-search'"
                    ></i>
                    Cari
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    :disabled="loading"
                    @click="resetFilters"
                  >
                    Atur Ulang
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card afu-list-card">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap mb-3"
              >
                <div>
                  <h5 class="mb-0">Daftar Alur Follow Up</h5>
                  <small class="text-muted" v-if="!loading || rows.length">
                    {{ totalRecords }} alur ditemukan
                  </small>
                </div>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  :disabled="loading || statsLoading"
                  @click="refreshAll"
                >
                  <i class="fa fa-refresh" :class="{ 'fa-spin': loading }"></i>
                  Muat Ulang
                </button>
              </div>

              <div
                v-if="listError"
                class="alert alert-danger d-flex align-items-center justify-content-between flex-wrap"
              >
                <span>
                  <i class="fa fa-exclamation-triangle"></i>
                  {{ listErrorMessage }}
                </span>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  :disabled="loading"
                  @click="loadList"
                >
                  Coba Lagi
                </button>
              </div>

              <div v-if="loading && !rows.length" class="afu-skeleton">
                <Skeleton :count="6" height="52px" gap="10px" />
              </div>

              <div
                v-else-if="!loading && !rows.length && !listError"
                class="afu-empty-state"
              >
                <div class="afu-empty-icon">
                  <i
                    :class="
                      hasActiveFilters ? 'fa fa-search' : 'fa fa-bolt'
                    "
                  ></i>
                </div>
                <h5>
                  {{
                    hasActiveFilters
                      ? "Tidak ada alur yang sesuai"
                      : "Belum ada alur Follow Up"
                  }}
                </h5>
                <p class="text-muted">
                  {{
                    hasActiveFilters
                      ? "Coba ubah kata kunci pencarian atau filter status."
                      : "Buat alur pertama untuk mulai mengirim pesan otomatis ke pelanggan."
                  }}
                </p>
                <button
                  v-if="hasActiveFilters"
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="resetFilters"
                >
                  Atur Ulang Filter
                </button>
                <router-link
                  v-else
                  :to="createRoute"
                  class="btn afu-primary-btn"
                >
                  <i class="fa fa-plus"></i>
                  Buat Alur Follow Up
                </router-link>
              </div>

              <div v-else-if="rows.length" class="table-responsive">
                <table class="table table-hover custom-table mb-0 afu-table">
                  <thead>
                    <tr>
                      <th>Nama Alur</th>
                      <th>Nomor Pengirim</th>
                      <th class="text-center">Jumlah Kontak</th>
                      <th class="text-center" :title="stepCountTooltip">
                        Jumlah Pesan
                      </th>
                      <th>Status</th>
                      <th>Jadwal Berikutnya</th>
                      <th class="text-center">Kuota Hari Ini</th>
                      <th>Aktivitas Terakhir</th>
                      <th class="text-right">Tindakan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in rows" :key="row.id">
                      <td>
                        <router-link
                          class="afu-flow-name"
                          :to="detailRoute(row)"
                          :title="row.name || ''"
                        >
                          {{ row.name || "-" }}
                        </router-link>
                        <small
                          v-if="row.description"
                          class="text-muted afu-flow-desc"
                          :title="row.description"
                        >
                          {{ row.description }}
                        </small>
                      </td>
                      <td>
                        <div class="afu-sender" :title="licenseLabel(row)">
                          {{ licenseLabel(row) }}
                        </div>
                        <small
                          v-if="licenseSubLabel(row)"
                          class="text-muted"
                        >
                          {{ licenseSubLabel(row) }}
                        </small>
                      </td>
                      <td class="text-center">
                        {{ row.total_recipients || 0 }}
                      </td>
                      <td
                        class="text-center"
                        :title="stepCountTooltip"
                      >
                        {{ stepCountLabel(row) }}
                      </td>
                      <td>
                        <span
                          class="afu-status-badge"
                          :class="'afu-status-' + statusTone(row.status)"
                        >
                          {{ statusLabel(row.status) }}
                        </span>
                      </td>
                      <td>
                        <template v-if="row.status === 'active'">
                          <div
                            v-if="Number(row.next_scheduled_at) > 0"
                            class="afu-next-schedule"
                          >
                            {{ formatScheduleDate(row.next_scheduled_at, row.timezone) }}
                          </div>
                          <span
                            class="afu-schedule-hint"
                            :class="scheduleHintTone(row)"
                          >
                            {{ scheduleHint(row) }}
                          </span>
                          <small
                            v-if="row.schedule_reason_code"
                            class="d-block text-muted mt-1"
                            :title="row.schedule_reason || ''"
                          >
                            {{ scheduleReasonLabel(row.schedule_reason_code) }}
                          </small>
                        </template>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td class="text-center">
                        <template v-if="row.quota">
                          <span
                            class="afu-quota-mini"
                            :class="row.quota.status !== 'normal' ? 'afu-quota-mini-reached' : 'afu-quota-mini-normal'"
                            :title="quotaTooltip(row.quota)"
                          >
                            {{ row.quota.remaining_count }}/{{ row.quota.daily_limit }}
                          </span>
                          <small class="d-block text-muted" :title="quotaTooltip(row.quota)">
                            {{ row.quota.status_label || (row.quota.status === "normal" ? "Tersisa" : "Tercapai") }}
                          </small>
                        </template>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>{{ formatDate(row.update_datetime) }}</td>
                      <td class="text-right afu-actions-cell">
                        <div class="afu-row-actions">
                          <button
                            type="button"
                            class="btn btn-sm afu-icon-btn"
                            title="Lihat detail"
                            aria-label="Lihat detail"
                            :disabled="!!actionLoadingId || loading"
                            @click="goDetail(row)"
                          >
                            <i class="fa fa-eye"></i>
                          </button>
                          <button
                            v-if="canEdit(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn"
                            title="Ubah"
                            aria-label="Ubah"
                            :disabled="!!actionLoadingId || loading"
                            @click="goEdit(row)"
                          >
                            <i class="fa fa-pencil"></i>
                          </button>
                          <button
                            v-if="canActivate(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn afu-icon-success"
                            title="Aktifkan"
                            aria-label="Aktifkan"
                            :disabled="!!actionLoadingId || loading"
                            @click="confirmAction(row, 'activate')"
                          >
                            <i
                              :class="
                                actionLoadingId === row.id &&
                                actionLoadingType === 'activate'
                                  ? 'fa fa-spinner fa-spin'
                                  : 'fa fa-play'
                              "
                            ></i>
                          </button>
                          <button
                            v-if="canPause(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn afu-icon-warning"
                            title="Jeda"
                            aria-label="Jeda"
                            :disabled="!!actionLoadingId || loading"
                            @click="confirmAction(row, 'pause')"
                          >
                            <i
                              :class="
                                actionLoadingId === row.id &&
                                actionLoadingType === 'pause'
                                  ? 'fa fa-spinner fa-spin'
                                  : 'fa fa-pause'
                              "
                            ></i>
                          </button>
                          <button
                            v-if="canResume(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn afu-icon-success"
                            title="Lanjutkan"
                            aria-label="Lanjutkan"
                            :disabled="!!actionLoadingId || loading"
                            @click="confirmAction(row, 'resume')"
                          >
                            <i
                              :class="
                                actionLoadingId === row.id &&
                                actionLoadingType === 'resume'
                                  ? 'fa fa-spinner fa-spin'
                                  : 'fa fa-play'
                              "
                            ></i>
                          </button>
                          <button
                            v-if="canCancel(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn afu-icon-danger"
                            title="Batalkan"
                            aria-label="Batalkan"
                            :disabled="!!actionLoadingId || loading"
                            @click="confirmAction(row, 'cancel')"
                          >
                            <i
                              :class="
                                actionLoadingId === row.id &&
                                actionLoadingType === 'cancel'
                                  ? 'fa fa-spinner fa-spin'
                                  : 'fa fa-ban'
                              "
                            ></i>
                          </button>
                          <button
                            v-if="canDelete(row)"
                            type="button"
                            class="btn btn-sm afu-icon-btn afu-icon-danger"
                            title="Hapus"
                            aria-label="Hapus"
                            :disabled="!!actionLoadingId || loading"
                            @click="confirmAction(row, 'delete')"
                          >
                            <i
                              :class="
                                actionLoadingId === row.id &&
                                actionLoadingType === 'delete'
                                  ? 'fa fa-spinner fa-spin'
                                  : 'fa fa-trash'
                              "
                            ></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="rows.length" class="row align-items-center mt-3">
                <div class="col-sm-12 col-md-6 mb-2 mb-md-0">
                  <span class="footer__row-count__label">Tampilkan</span>
                  <select
                    v-model.number="perPage"
                    class="select-to-paginasi"
                    style="width: 110px;"
                    :disabled="loading"
                    @change="onPerPageChange"
                  >
                    <option :value="10">10 / halaman</option>
                    <option :value="20">20 / halaman</option>
                    <option :value="50">50 / halaman</option>
                    <option :value="100">100 / halaman</option>
                  </select>
                  <span class="footer__row-count__label">
                    dari {{ totalRecords }} alur
                  </span>
                </div>
                <div class="col-sm-12 col-md-6 text-right">
                  <a
                    href="javascript:void(0)"
                    class="btn"
                    :class="{ disabled: currentPage <= 1 || loading }"
                    @click.prevent="onPrevChange"
                  >
                    Sebelumnya
                  </a>
                  <span class="afu-page-label">Halaman</span>
                  <input
                    v-model.number="pageInput"
                    type="number"
                    min="1"
                    :max="lastPage"
                    class="afu-page-input"
                    :disabled="loading"
                    @keyup.enter="onPageChange(pageInput)"
                  />
                  <span class="afu-page-label">dari {{ lastPage }}</span>
                  <a
                    href="javascript:void(0)"
                    class="btn"
                    :class="{
                      disabled: currentPage >= lastPage || loading
                    }"
                    @click.prevent="onNextChange"
                  >
                    Berikutnya
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-tour
      :key="tourKey"
      name="afuTourGuide"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
      @targetNotFound="handleTourTargetNotFound"
    ></v-tour>

    <button
      v-if="tourRunning"
      type="button"
      class="afu-tour-close"
      aria-label="Tutup panduan fitur"
      title="Tutup panduan"
      @click="stopTour"
    >
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { formatLocalDate } from "@/utils/helper";

function scrollTourTarget(selector) {
  return function () {
    return new Promise(resolve => {
      const target = document.querySelector(selector);
      if (target) {
        target.scrollIntoView({ behavior: "auto", block: "center" });
      }
      resolve();
    });
  };
}

export default {
  name: "auto-follow-up-list",
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      showBetaBanner: true,
      betaBannerStorageKey: "AutoFollowUp-Beta-Banner-Dismissed",
      tourRunning: false,
      tourKey: 0,
      tourOptions: {
        highlight: true,
        labels: {
          buttonSkip: "Lewati",
          buttonPrevious: "Kembali",
          buttonNext: "Lanjut",
          buttonStop: "Selesai"
        },
        useKeyboardNavigation: true,
        stopOnTargetNotFound: true,
        startTimeout: 0,
        enabledNavigationKeys: {
          escape: true,
          arrowRight: true,
          arrowLeft: true
        }
      },
      tourCallbacks: {
        onStart: this.onTourStart,
        onStop: this.cleanupTour,
        onSkip: this.cleanupTour,
        onFinish: this.cleanupTour
      },
      tourSteps: [
        {
          target: '[data-tour="afu-intro"]',
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 1 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-bolt"></i></div>
              <h4>Mengenal Auto Follow Up</h4>
              <p>Auto Follow Up mengirim rangkaian pesan WhatsApp sesuai jadwal kepada kontak yang dipilih. Fitur ini masih Beta, jadi mulai dari sejumlah kecil kontak dan periksa hasilnya.</p>
              <div class="afu-tour-progress"><span style="width: 17%"></span></div>
            </div>
          `,
          before: scrollTourTarget('[data-tour="afu-intro"]'),
          params: {
            placement: "bottom",
            enableScrolling: false,
            modifiers: [
              { name: "offset", options: { offset: [0, 12] } },
              {
                name: "preventOverflow",
                options: { rootBoundary: "viewport", padding: 12 }
              },
              { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } }
            ]
          }
        },
        {
          target: '[data-tour="afu-list-tools"]',
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 2 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-list-alt"></i></div>
              <h4>Daftar alur</h4>
              <p>Di halaman ini Anda bisa melihat daftar alur, status, dan aktivitas terakhir. Gunakan pencarian atau filter status untuk menemukan alur. Klik nama alur untuk melihat detail.</p>
              <div class="afu-tour-progress"><span style="width: 33%"></span></div>
            </div>
          `,
          before: scrollTourTarget('[data-tour="afu-list-tools"]'),
          params: {
            placement: "bottom",
            enableScrolling: false,
            modifiers: [
              { name: "offset", options: { offset: [0, 12] } },
              {
                name: "preventOverflow",
                options: { rootBoundary: "viewport", padding: 12 }
              },
              { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } }
            ]
          }
        },
        {
          target: '[data-tour="afu-create"]',
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 3 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-plus"></i></div>
              <h4>Membuat alur baru</h4>
              <p>Klik Buat Alur Follow Up untuk membuka formulir. Di sana Anda mengatur nomor pengirim, sumber kontak, pesan, dan jadwal. Panduan ini tidak membuat alur atau mengisi formulir.</p>
              <div class="afu-tour-progress"><span style="width: 50%"></span></div>
            </div>
          `,
          before: scrollTourTarget('[data-tour="afu-create"]'),
          params: {
            placement: "bottom",
            enableScrolling: false,
            modifiers: [
              { name: "offset", options: { offset: [0, 12] } },
              {
                name: "preventOverflow",
                options: { rootBoundary: "viewport", padding: 12 }
              },
              { name: "flip", options: { fallbackPlacements: ["bottom", "top"] } }
            ]
          }
        },
        {
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 4 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-users"></i></div>
              <h4>Memilih kontak</h4>
              <p>Pilih kontak dari grup, tag, atau kontak manual. Waajo menentukan daftar kontak saat alur diaktifkan. Kontak yang ditambahkan ke grup atau tag setelah aktivasi tidak otomatis ikut.</p>
              <div class="afu-tour-note"><i class="fa fa-info-circle"></i> Langkah ini menjelaskan halaman formulir. Panduan tidak membuka atau mengisi formulir.</div>
              <div class="afu-tour-progress"><span style="width: 67%"></span></div>
            </div>
          `,
          params: { highlight: false }
        },
        {
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 5 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-clock-o"></i></div>
              <h4>Mengatur pesan dan jadwal</h4>
              <p>Atur isi pesan, urutan, jeda, dan jam pengiriman. Setelah alur berjalan, pesan dan sumber kontak tidak bisa diubah; periksa kembali sebelum aktivasi.</p>
              <div class="afu-tour-note"><i class="fa fa-info-circle"></i> Langkah ini menjelaskan halaman formulir. Panduan tidak mengubah pesan atau jadwal.</div>
              <div class="afu-tour-progress"><span style="width: 83%"></span></div>
            </div>
          `,
          params: { highlight: false }
        },
        {
          content: `
            <div class="afu-tour-card">
              <div class="afu-tour-topline">
                <span class="afu-tour-kicker">Langkah 6 dari 6</span>
                <span class="afu-tour-beta">BETA</span>
              </div>
              <div class="afu-tour-icon"><i class="fa fa-paper-plane"></i></div>
              <h4>Aktivasi dan pemantauan</h4>
              <p>Periksa nomor pengirim, sumber kontak, pesan, dan jadwal sebelum mengaktifkan alur. Setelah aktif, pantau kontak dan riwayat di halaman detail. Menunggu giliran dikirim berarti pesan belum tentu sudah terkirim. Berhasil dikirim berarti Waajo sudah mengirim pesan, tetapi belum tentu sudah dibaca.</p>
              <div class="afu-tour-note"><i class="fa fa-info-circle"></i> Buka detail alur untuk melihat hasil dan riwayatnya.</div>
              <div class="afu-tour-progress"><span style="width: 100%"></span></div>
            </div>
          `,
          params: { highlight: false }
        }
      ],
      loading: false,
      listError: false,
      listErrorMessage: "",
      rows: [],
      totalRecords: 0,
      totalPages: 0,
      currentPage: 1,
      pageInput: 1,
      perPage: 20,
      filters: {
        search: "",
        status: ""
      },
      statusOptions: [
        { value: "", label: "Semua Status" },
        { value: "draft", label: "Draf" },
        { value: "active", label: "Aktif" },
        { value: "paused", label: "Dijeda" },
        { value: "completed", label: "Selesai" },
        { value: "cancelled", label: "Dibatalkan" }
      ],
      statCards: [
        {
          key: "total_flows",
          label: "Total Alur",
          icon: "fa fa-random",
          tone: "orange",
          hint: "Seluruh alur Follow Up yang belum dihapus."
        },
        {
          key: "active_flows",
          label: "Alur Aktif",
          icon: "fa fa-play-circle",
          tone: "green",
          hint: "Alur yang sedang berjalan."
        },
        {
          key: "paused_flows",
          label: "Alur Dijeda",
          icon: "fa fa-pause-circle",
          tone: "amber",
          hint: "Alur yang sedang dijeda."
        },
        {
          key: "progress_recipients",
          label: "Kontak Menunggu & Sedang Diproses",
          icon: "fa fa-users",
          tone: "blue",
          hint: "Kontak yang masih menunggu atau sedang diproses."
        }
      ],
      stats: null,
      statsLoading: false,
      statsError: false,
      licensesLoading: false,
      licenseMap: {},
      actionLoadingId: "",
      actionLoadingType: ""
    };
  },
  computed: {
    createRoute() {
      return { path: "/auto-follow-up/wizard" };
    },
    lastPage() {
      return Math.max(Number(this.totalPages) || 0, 1);
    },
    hasActiveFilters() {
      return !!(
        (this.filters.search || "").trim() !== "" ||
        (this.filters.status || "") !== ""
      );
    },
    stepCountTooltip() {
      return "Jumlah pesan dalam alur.";
    }
  },
  created() {
    this.initializeBetaBanner();
    this.loadList();
    this.loadStats();
    this.loadLicenses();
  },
  beforeDestroy() {
    this.stopTour();
  },
  methods: {
    initializeBetaBanner() {
      try {
        this.showBetaBanner =
          window.localStorage.getItem(this.betaBannerStorageKey) !== "1";
      } catch (error) {
        this.showBetaBanner = true;
      }
    },
    dismissBetaBanner() {
      this.showBetaBanner = false;
      try {
        window.localStorage.setItem(this.betaBannerStorageKey, "1");
      } catch (error) {
        // localStorage bisa tidak tersedia; banner tetap ditutup untuk sesi ini.
      }
    },
    startTour() {
      if (this.tourRunning) {
        return;
      }

      // Recreate VTour agar tour dapat dimulai ulang dengan bersih setelah
      // langkah sticky (tanpa target) selesai.
      this.tourKey += 1;
      document.body.classList.add("afu-tour-active");
      this.tourRunning = true;

      this.$nextTick(() => {
        const tour = this.$tours && this.$tours["afuTourGuide"];
        if (!tour || typeof tour.start !== "function") {
          this.cleanupTour();
          this.$fire({
            title: "Panduan belum siap",
            text: "Panduan fitur belum dapat dimuat. Silakan muat ulang halaman.",
            type: "warning",
            timer: 2600
          });
          return;
        }

        Promise.resolve(tour.start()).catch(() => {
          this.stopTour();
          this.$fire({
            title: "Panduan terhenti",
            text: "Panduan tidak dapat dilanjutkan. Silakan coba lagi.",
            type: "warning",
            timer: 2600
          });
        });
      });
    },
    onTourStart() {
      this.tourRunning = true;
      document.body.classList.add("afu-tour-active");
    },
    stopTour() {
      const tour = this.$tours && this.$tours["afuTourGuide"];
      if (tour && typeof tour.stop === "function" && tour.isRunning) {
        tour.stop();
      }
      this.cleanupTour();
    },
    cleanupTour() {
      this.tourRunning = false;
      document.body.classList.remove("afu-tour-active");
      [
        '[data-tour="afu-intro"]',
        '[data-tour="afu-list-tools"]',
        '[data-tour="afu-create"]',
        '[data-tour="afu-beta-banner"]'
      ].forEach(selector => {
        const target = document.querySelector(selector);
        if (!target) {
          return;
        }
        target.classList.remove("v-tour__target--highlighted");
        target.classList.remove("v-tour__target--relative");
      });
    },
    handleTourTargetNotFound() {
      this.stopTour();
      this.$fire({
        title: "Panduan terhenti",
        text: "Bagian halaman yang dijelaskan tidak ditemukan. Panduan ditutup agar halaman tetap dapat digunakan.",
        type: "warning",
        timer: 3000
      });
    },
    formatDate(value) {
      const unix = Number(value);
      if (!unix || unix <= 0) {
        return "-";
      }
      return formatLocalDate(unix);
    },
    timezoneLabel(timezone) {
      const tz = timezone || "Asia/Jakarta";
      if (tz === "Asia/Jakarta") return "WIB";
      if (tz === "Asia/Makassar") return "WITA";
      if (tz === "Asia/Jayapura") return "WIT";
      return tz;
    },
    formatScheduleDate(value, timezone) {
      const unix = Number(value);
      if (!unix || unix <= 0) {
        return "-";
      }
      const tz = timezone || "Asia/Jakarta";
      try {
        const parts = new Intl.DateTimeFormat("id-ID", {
          timeZone: tz,
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        }).formatToParts(new Date(unix * 1000));
        const pick = type => {
          const found = parts.find(part => part.type === type);
          return found ? found.value : "";
        };
        return (
          pick("day") +
          " " +
          pick("month") +
          " " +
          pick("year") +
          ", " +
          pick("hour") +
          ":" +
          pick("minute") +
          " " +
          this.timezoneLabel(tz)
        );
      } catch (error) {
        return this.formatDate(unix);
      }
    },
    scheduleHint(row) {
      if (!row || row.status !== "active") {
        return "";
      }
      const next = Number(row.next_scheduled_at) || 0;
      const server = Number(row.server_time) || 0;
      if (row.schedule_state === "overdue" || (next > 0 && server > 0 && next <= server)) {
        return "Sudah waktunya dikirim";
      }
      if (next > 0) {
        return "Menunggu jadwal";
      }
      if (row.schedule_state === "completed") {
        return "Semua pesan sudah diproses";
      }
      if (row.schedule_state === "failed" || row.schedule_state === "uncertain") {
        return "Perlu dijadwalkan ulang";
      }
      return row.schedule_label || "Menunggu jadwal berikutnya";
    },
    scheduleHintTone(row) {
      const hint = this.scheduleHint(row);
      if (hint === "Sudah waktunya dikirim" || hint === "Perlu dijadwalkan ulang") {
        return "is-attention";
      }
      if (hint === "Menunggu jadwal") {
        return "is-waiting";
      }
      return "is-neutral";
    },
    statsValue(key) {
      if (!this.stats) {
        return "-";
      }
      const value = this.stats[key];
      if (typeof value === "undefined" || value === null) {
        return "-";
      }
      return value;
    },
    statusLabel(status) {
      const labels = {
        draft: "Draf",
        active: "Aktif",
        paused: "Dijeda",
        completed: "Selesai",
        cancelled: "Dibatalkan"
      };
      return labels[status] || "Status tidak dikenal";
    },
    quotaTooltip(quota) {
      if (!quota) {
        return "";
      }
      return (
        "Lisensi " +
        (quota.license_phone_number || quota.license_id || "-") +
        " · Terkirim " +
        (quota.sent_count || 0) +
        " · Reservasi " +
        (quota.reserved_count || 0) +
        " · Terpakai " +
        (quota.used_count || 0) +
        " · Gagal " +
        (quota.failed_count || 0) +
        " · Reset " +
        this.formatQuotaReset(quota)
      );
    },
    formatQuotaReset(quota) {
      if (!quota || !quota.reset_at) {
        return "-";
      }
      try {
        return new Intl.DateTimeFormat("id-ID", {
          timeZone: quota.timezone || "Asia/Jakarta",
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        }).format(new Date(Number(quota.reset_at) * 1000));
      } catch (error) {
        return this.formatDate(quota.reset_at);
      }
    },
    scheduleReasonLabel(code) {
      const labels = {
        no_eligible_recipient: "Tidak ada penerima aktif",
        outside_sending_window: "Di luar jam pengiriman",
        daily_limit_reached: "Batas harian lisensi tercapai",
        license_quota_reserved: "Kuota lisensi sedang terpakai",
        sender_not_ready: "Nomor pengirim belum siap",
        prepare_pending: "Sedang menyiapkan pengiriman",
        enqueue_pending: "Menunggu antrean pengiriman",
        scheduler_error: "Data jadwal perlu diperiksa",
        prepare_insert_failed: "Pengiriman belum dapat disiapkan",
        prepare_lookup_failed: "Data pengiriman belum dapat dibaca",
        prepare_reset_failed: "Pengiriman belum dapat diperbarui",
        quota_reservation_failed: "Kuota belum dapat dialokasikan",
        redis_enqueue_failed: "Pengiriman belum masuk antrean",
        task_id_persist_failed: "Status pengiriman sedang dipulihkan",
        waiting_next_schedule: "Menunggu jadwal berikutnya",
        no_schedule: "Belum ada jadwal"
      };
      return labels[code] || "";
    },
    statusTone(status) {
      if (
        ["draft", "active", "paused", "completed", "cancelled"].indexOf(
          status
        ) !== -1
      ) {
        return status;
      }
      return "draft";
    },
    licenseLabel(row) {
      const id = row && row.license_id;
      if (!id) {
        return "-";
      }
      const license = this.licenseMap[id];
      if (license) {
        return (
          license.license_phone_number ||
          license.license_name ||
          "Nomor WhatsApp"
        );
      }
      if (this.licensesLoading) {
        return "Memuat nomor pengirim...";
      }
      return "Nomor pengirim belum dapat dimuat";
    },
    licenseSubLabel(row) {
      const id = row && row.license_id;
      if (!id) {
        return "";
      }
      const license = this.licenseMap[id];
      if (!license) {
        return "";
      }
      const primary =
        license.license_phone_number || license.license_name || "";
      if (license.license_name && license.license_name !== primary) {
        return license.license_name;
      }
      return "";
    },
    stepCountLabel(row) {
      let count = null;
      if (
        row &&
        typeof row.steps_count !== "undefined" &&
        row.steps_count !== null
      ) {
        count = row.steps_count;
      } else if (
        row &&
        typeof row.step_count !== "undefined" &&
        row.step_count !== null
      ) {
        count = row.step_count;
      } else if (row && Array.isArray(row.steps)) {
        count = row.steps.length;
      }
      return count === null ? "—" : count;
    },
    canEdit(row) {
      return ["draft", "active", "paused"].indexOf(row.status) !== -1;
    },
    canActivate(row) {
      return row.status === "draft";
    },
    canPause(row) {
      return row.status === "active";
    },
    canResume(row) {
      return row.status === "paused";
    },
    canCancel(row) {
      return ["active", "paused"].indexOf(row.status) !== -1;
    },
    canDelete(row) {
      return ["draft", "completed", "cancelled"].indexOf(row.status) !== -1;
    },
    editRoute(row) {
      return {
        path: "/auto-follow-up/wizard",
        query: { id: row.id }
      };
    },
    detailRoute(row) {
      return {
        path: "/auto-follow-up/detail",
        query: { id: row.id }
      };
    },
    goDetail(row) {
      if (this.actionLoadingId || this.loading) {
        return;
      }
      this.$router.push(this.detailRoute(row));
    },
    goEdit(row) {
      if (this.actionLoadingId || this.loading) {
        return;
      }
      this.$router.push(this.editRoute(row));
    },
    extractErrorMessage(error, fallback) {
      let message = "";
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.msg
      ) {
        message = error.response.data.msg;
      } else if (error && error.message) {
        message = error.message;
      }
      if (!message) {
        return fallback;
      }

      const text = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      const lower = text.toLowerCase();

      if (lower.indexOf("flow name is required") !== -1) {
        return "Nama alur wajib diisi.";
      }
      if (
        lower.indexOf("sender license") !== -1 ||
        lower.indexOf("license is not active") !== -1 ||
        lower.indexOf("license is not found") !== -1
      ) {
        return "Nomor WhatsApp pengirim tidak ditemukan atau belum aktif. Pilih nomor lain yang tersedia.";
      }
      if (
        lower.indexOf("no contacts found") !== -1 ||
        lower.indexOf("contact source") !== -1
      ) {
        return "Belum ada kontak yang sesuai dengan sumber yang dipilih. Periksa grup, tag, atau kontak.";
      }
      if (lower.indexOf("at least one contact source") !== -1) {
        return "Pilih minimal satu sumber kontak.";
      }
      if (lower.indexOf("at least one step") !== -1) {
        return "Tambahkan minimal satu pesan.";
      }
      if (lower.indexOf("flow cannot be activated from status") !== -1) {
        return "Alur ini tidak bisa diaktifkan pada status saat ini.";
      }
      if (lower.indexOf("steps cannot") !== -1) {
        return "Pesan dan sumber kontak tidak dapat diubah saat alur berjalan atau dijeda.";
      }
      if (lower.indexOf("recipient is not found") !== -1) {
        return "Kontak penerima tidak ditemukan. Muat ulang daftar kontak.";
      }
      if (lower.indexOf("only active flows can be paused") !== -1) {
        return "Alur ini belum bisa dijeda karena statusnya tidak aktif.";
      }
      if (lower.indexOf("only paused flows can be resumed") !== -1) {
        return "Alur ini belum bisa dilanjutkan karena tidak sedang dijeda.";
      }
      if (lower.indexOf("only active or paused flows can be cancelled") !== -1) {
        return "Alur ini tidak dapat dibatalkan pada status saat ini.";
      }
      if (
        lower.indexOf("auto follow up flow is not found") !== -1 ||
        lower.indexOf("flow is not found") !== -1
      ) {
        return "Alur tidak ditemukan. Muat ulang halaman daftar.";
      }
      if (lower.indexOf("data yang dikirim tidak valid") !== -1) {
        return "Data yang dikirim belum sesuai. Periksa kembali pengaturan alur.";
      }
      if (lower.indexOf("terjadi kesalahan pada server") !== -1) {
        return "Terjadi kendala saat memproses permintaan. Coba lagi.";
      }
      if (
        lower.indexOf("unauthorized") !== -1 ||
        lower.indexOf("forbidden") !== -1 ||
        lower.indexOf("not authorized") !== -1 ||
        lower.indexOf("permission") !== -1
      ) {
        return "Anda tidak memiliki akses untuk tindakan ini.";
      }
      if (
        lower.indexOf("timeout") !== -1 ||
        lower.indexOf("network") !== -1 ||
        lower.indexOf("connection") !== -1
      ) {
        return "Koneksi bermasalah. Periksa jaringan Anda dan coba lagi.";
      }
      if (lower.indexOf("not found") !== -1) {
        return "Data yang diminta tidak ditemukan. Muat ulang halaman.";
      }
      if (
        lower.indexOf("sql") !== -1 ||
        lower.indexOf("select ") !== -1 ||
        lower.indexOf("table") !== -1 ||
        lower.indexOf("column") !== -1 ||
        lower.indexOf("backend") !== -1 ||
        lower.indexOf("redis") !== -1 ||
        lower.indexOf("worker") !== -1 ||
        lower.indexOf("invalid") !== -1 ||
        lower.indexOf("failed") !== -1 ||
        lower.indexOf("error") !== -1 ||
        text.indexOf("<") !== -1
      ) {
        return fallback;
      }

      return text;
    },
    async loadList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.listError = false;
      this.listErrorMessage = "";
      try {
        const response = await this.$store.dispatch(
          "autoFollowUp/listAutoFollowUp",
          {
            page: this.currentPage,
            per_page: this.perPage,
            search: (this.filters.search || "").trim(),
            status: this.filters.status || ""
          }
        );
        const payload = response && response.data ? response.data : {};
        this.rows = Array.isArray(payload.data) ? payload.data : [];
        this.totalRecords = Number(payload.totalRecords) || 0;
        this.totalPages = Number(payload.totalPages) || 0;
        this.currentPage = Number(payload.page) || this.currentPage;
        this.perPage = Number(payload.perPage) || this.perPage;
        this.pageInput = this.currentPage;
      } catch (error) {
        this.listError = true;
        this.listErrorMessage = this.extractErrorMessage(
          error,
          "Daftar alur belum dapat dimuat. Coba lagi."
        );
      } finally {
        this.loading = false;
      }
    },
    async loadStats() {
      if (this.statsLoading) {
        return;
      }
      this.statsLoading = true;
      this.statsError = false;
      try {
        const response = await this.$store.dispatch(
          "autoFollowUp/statsAutoFollowUp",
          {}
        );
        this.stats = response && response.data ? response.data : null;
        if (!this.stats) {
          this.statsError = true;
        }
      } catch (error) {
        this.stats = null;
        this.statsError = true;
      } finally {
        this.statsLoading = false;
      }
    },
    async loadLicenses() {
      if (this.licensesLoading) {
        return;
      }
      this.licensesLoading = true;
      try {
        const response = await this.$store.dispatch(
          "license/getLicenseList",
          {
            page: 0,
            perPage: 100,
            license_name: "",
            license_phone_number: "",
            license_status: ""
          }
        );
        const list =
          response &&
          response.data &&
          Array.isArray(response.data.data)
            ? response.data.data
            : [];
        const map = {};
        list.forEach(license => {
          if (license && license.id) {
            map[license.id] = license;
          }
        });
        this.licenseMap = map;
      } catch (error) {
        this.licenseMap = {};
      } finally {
        this.licensesLoading = false;
      }
    },
    async refreshAll() {
      await Promise.all([
        this.loadList(),
        this.loadStats(),
        this.loadLicenses()
      ]);
    },
    applyFilters() {
      this.currentPage = 1;
      this.pageInput = 1;
      this.loadList();
    },
    resetFilters() {
      this.filters.search = "";
      this.filters.status = "";
      this.currentPage = 1;
      this.pageInput = 1;
      this.loadList();
    },
    onPerPageChange() {
      this.currentPage = 1;
      this.pageInput = 1;
      this.loadList();
    },
    onPageChange(page) {
      const target = Math.min(
        Math.max(Number(page) || 1, 1),
        this.lastPage
      );
      if (target === this.currentPage) {
        this.pageInput = this.currentPage;
        return;
      }
      this.currentPage = target;
      this.pageInput = target;
      this.loadList();
    },
    onPrevChange() {
      if (this.currentPage > 1) {
        this.onPageChange(this.currentPage - 1);
      }
    },
    onNextChange() {
      if (this.currentPage < this.lastPage) {
        this.onPageChange(this.currentPage + 1);
      }
    },
    getActionConfirm(action, row) {
      const name = row.name || "alur ini";
      const configs = {
        activate: {
          title: "Aktifkan alur Follow Up?",
          text:
            'Alur "' +
            name +
            '" akan mulai dijadwalkan. Waajo akan menentukan daftar kontak saat alur diaktifkan.'
        },
        pause: {
          title: "Jeda alur Follow Up?",
          text:
            "Pesan yang masih menunggu giliran dan belum diambil sistem pengiriman akan ditahan sampai alur dilanjutkan. Pesan yang sudah diproses atau terkirim tidak bisa ditarik."
        },
        resume: {
          title: "Lanjutkan alur Follow Up?",
          text: 'Alur "' + name + '" akan berjalan lagi. Pesan yang tertunda mengikuti jadwal yang tersimpan.'
        },
        cancel: {
          title: "Batalkan alur Follow Up?",
          text:
            "Pesan yang dijadwalkan akan dibatalkan. Pesan yang masih menunggu giliran dan belum diambil sistem tidak akan dikirim. Pesan yang sudah diproses atau terkirim tidak bisa ditarik. Kontak yang belum selesai akan dihentikan. Tindakan ini tidak bisa dibatalkan."
        },
        delete: {
          title: "Hapus alur Follow Up?",
          text:
            'Alur "' +
            name +
            '" akan dihapus dari daftar. Pesan yang dijadwalkan dibatalkan, pesan yang menunggu giliran tidak akan dikirim, dan kontak yang belum selesai dihentikan. Pesan yang sudah diproses atau terkirim tidak bisa ditarik.'
        }
      };
      return (
        configs[action] || {
          title: "Konfirmasi",
          text: "Lanjutkan tindakan ini?"
        }
      );
    },
    getActionSuccessMessage(action, row) {
      const name = row.name || "Alur";
      const messages = {
        activate: 'Alur "' + name + '" berhasil diaktifkan.',
        pause: 'Alur "' + name + '" berhasil dijeda.',
        resume: 'Alur "' + name + '" berhasil dilanjutkan.',
        cancel: 'Alur "' + name + '" berhasil dibatalkan.',
        delete: 'Alur "' + name + '" berhasil dihapus.'
      };
      return messages[action] || "Tindakan berhasil.";
    },
    async confirmAction(row, action) {
      if (this.actionLoadingId || this.loading) {
        return;
      }
      const config = this.getActionConfirm(action, row);
      const result = await this.$fire({
        title: config.title,
        text: config.text,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjutkan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#FE9B44"
      });
      if (!result || !result.value) {
        return;
      }
      await this.executeAction(row, action);
    },
    async executeAction(row, action) {
      if (this.actionLoadingId) {
        return;
      }
      const dispatchNames = {
        activate: "activateAutoFollowUp",
        pause: "pauseAutoFollowUp",
        resume: "resumeAutoFollowUp",
        cancel: "cancelAutoFollowUp",
        delete: "deleteAutoFollowUp"
      };
      const dispatchName = dispatchNames[action];
      if (!dispatchName) {
        return;
      }

      this.actionLoadingId = row.id;
      this.actionLoadingType = action;
      try {
        await this.$store.dispatch("autoFollowUp/" + dispatchName, {
          id: row.id
        });

        if (
          action === "delete" &&
          this.rows.length === 1 &&
          this.currentPage > 1
        ) {
          this.currentPage -= 1;
          this.pageInput = this.currentPage;
        }

        await this.loadList();
        await this.loadStats();

        this.$fire({
          title: "Berhasil",
          text: this.getActionSuccessMessage(action, row),
          type: "success",
          timer: 2200
        });
      } catch (error) {
        // requestRaw menampilkan pesan error backend secara global.
      } finally {
        this.actionLoadingId = "";
        this.actionLoadingType = "";
      }
    },
  }
};
</script>

<style scoped>
.afu-primary-btn {
  background-color: #fe9b44;
  border-color: #fe9b44;
  color: #ffffff;
}

.afu-primary-btn:hover,
.afu-primary-btn:focus {
  background-color: #f08a2e;
  border-color: #f08a2e;
  color: #ffffff;
}

.afu-primary-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.afu-beta-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 7px;
  padding: 2px 7px;
  border: 1px solid #ffd8b5;
  border-radius: 999px;
  background: #fff1e5;
  color: #d97a18;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.4px;
  vertical-align: middle;
}

.afu-beta-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px 16px;
  border: 1px solid #ffe1c4;
  border-radius: 12px;
  background: linear-gradient(100deg, #fff8f0 0%, #fffdfb 100%);
  color: #5f4a38;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.afu-beta-banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #fff1e5;
  color: #d97a18;
  font-size: 16px;
}

.afu-beta-banner-content {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  line-height: 1.55;
}

.afu-beta-banner-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 3px;
  color: #8a4b0f;
  font-size: 14px;
  font-weight: 700;
}

.afu-beta-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  background: #fe9b44;
  color: #ffffff;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.45px;
}

.afu-beta-banner-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  margin: -4px -4px 0 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #a07147;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.afu-beta-banner-close:hover,
.afu-beta-banner-close:focus {
  background: #fff1e5;
  color: #8a4b0f;
  outline: none;
}

.afu-tour-close {
  position: fixed;
  top: 90px;
  right: 22px;
  z-index: 10002;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #ffe1c4;
  border-radius: 50%;
  background: #ffffff;
  color: #8a4b0f;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  pointer-events: auto;
}

.afu-tour-close:hover,
.afu-tour-close:focus {
  background: #fff8f0;
  color: #d97a18;
  outline: none;
}

.afu-stat-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 16px;
}

.afu-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex: 0 0 44px;
}

.afu-stat-icon.orange {
  background: #fff1e5;
  color: #fe9b44;
}

.afu-stat-icon.green {
  background: #e7f6e4;
  color: #3f8f34;
}

.afu-stat-icon.amber {
  background: #fff7e0;
  color: #b8860b;
}

.afu-stat-icon.blue {
  background: #e8f0fe;
  color: #1a73e8;
}

.afu-stat-label {
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.4;
}

.afu-stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #343a40;
  line-height: 1.2;
  min-height: 29px;
}

.afu-alert {
  margin-bottom: 16px;
}

.afu-filter-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  margin-bottom: 16px;
}

.afu-filter-label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 6px;
}

.afu-list-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.afu-table {
  min-width: 980px;
}

.afu-quota-mini {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.afu-quota-mini-normal {
  color: #3f8f34;
  background: #e7f6e4;
}

.afu-quota-mini-reached {
  color: #dc3545;
  background: #fdecee;
}

.afu-table thead th {
  border-top: 0;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  color: #8c8c8c;
  font-weight: 600;
  white-space: nowrap;
}

.afu-table tbody td {
  vertical-align: middle;
  font-size: 14px;
}

.afu-flow-name {
  display: block;
  font-weight: 600;
  color: #343a40;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}

.afu-flow-name:hover {
  color: #fe9b44;
  text-decoration: none;
}

.afu-flow-desc {
  display: block;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.afu-sender {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.afu-next-schedule {
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
  line-height: 1.35;
}

.afu-schedule-hint {
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
}

.afu-schedule-hint.is-waiting {
  color: #b26a00;
}

.afu-schedule-hint.is-attention {
  color: #c0392b;
}

.afu-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.afu-status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  background: currentColor;
}

.afu-status-draft {
  background: #f1f3f5;
  color: #6c757d;
}

.afu-status-active {
  background: #e7f6e4;
  color: #3f8f34;
}

.afu-status-paused {
  background: #fff1e5;
  color: #d97a18;
}

.afu-status-completed {
  background: #e8f0fe;
  color: #1a73e8;
}

.afu-status-cancelled {
  background: #fdecee;
  color: #dc3545;
}

.afu-actions-cell {
  white-space: nowrap;
}

.afu-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.afu-icon-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  margin-left: 4px;
  border-radius: 50%;
  border: 1px solid #e9ecef;
  background: #ffffff;
  color: #6c757d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.afu-icon-btn:hover {
  background: #f8f9fa;
  color: #495057;
}

.afu-icon-success:hover {
  background: #f1fbf0;
  border-color: #c7e8c1;
  color: #3f8f34;
}

.afu-icon-warning:hover {
  background: #fff7ee;
  border-color: #f6d7b8;
  color: #d97a18;
}

.afu-icon-danger:hover {
  background: #fdf2f3;
  border-color: #f5c6cb;
  color: #dc3545;
}

.afu-icon-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.afu-empty-state {
  text-align: center;
  padding: 48px 16px;
}

.afu-empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fff1e5;
  color: #fe9b44;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 16px;
}

.afu-empty-state h5 {
  margin-bottom: 8px;
}

.afu-empty-state p {
  max-width: 420px;
  margin: 0 auto 18px;
}

.afu-skeleton {
  padding: 8px 0;
}

.afu-page-label {
  margin: 0 6px;
  color: #6c757d;
  font-size: 13px;
}

.afu-page-input {
  width: 64px;
  height: 34px;
  padding: 4px 6px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
}

@media (max-width: 575.98px) {
  .afu-header-action {
    width: 100%;
    margin-top: 12px;
  }

  .afu-header-action .btn {
    width: 100%;
  }

  .afu-header-action .afu-tour-btn,
  .afu-header-action .afu-template-btn {
    margin-right: 0 !important;
    margin-bottom: 8px;
  }

  .afu-beta-banner {
    gap: 10px;
    padding: 12px;
  }

  .afu-beta-banner-icon {
    flex-basis: 28px;
    width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .afu-beta-banner-content {
    font-size: 12px;
  }

  .afu-tour-close {
    top: 70px;
    right: 12px;
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 767.98px) {
  .afu-stat-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    font-size: 16px;
  }

  .afu-stat-value {
    font-size: 21px;
  }

  .afu-row-actions {
    justify-content: flex-start;
  }
}
</style>

<style>
/* Scoped ke tour Auto Follow Up melalui body.afu-tour-active agar tampilan
   Tour Guide Broadcast tidak berubah. */
body.afu-tour-active.v-tour--active::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(15, 23, 42, 0.58);
  pointer-events: none;
}

body.afu-tour-active .v-tour__target--highlighted {
  border-radius: 8px;
  box-shadow: 0 0 0 3px #fe9b44, 0 0 0 8px rgba(254, 155, 68, 0.18);
}

body.afu-tour-active .v-step {
  width: 380px;
  max-width: 380px;
  padding: 0;
  border: 1px solid #ffe1c4;
  border-radius: 16px;
  background: #ffffff;
  color: #2d3748;
  text-align: left;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

body.afu-tour-active .v-step__content {
  margin: 0;
  padding: 20px 20px 12px;
}

body.afu-tour-active .v-step__buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0 20px 18px;
}

body.afu-tour-active .v-step__button {
  min-height: 38px;
  height: auto;
  margin: 0;
  padding: 8px 14px;
  border: 1px solid #dee2e6;
  border-radius: 9px;
  background: #ffffff;
  color: #4a5568;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

body.afu-tour-active .v-step__button-skip {
  margin-right: auto;
  border-color: transparent;
  background: transparent;
  color: #8c8c8c;
}

body.afu-tour-active .v-step__button-skip:hover,
body.afu-tour-active .v-step__button-skip:focus {
  background: #f8f9fa;
  color: #5f6b7a;
}

body.afu-tour-active .v-step__button-previous:hover,
body.afu-tour-active .v-step__button-previous:focus {
  border-color: #fe9b44;
  background: #fff8f0;
  color: #d97a18;
}

body.afu-tour-active .v-step__button-next,
body.afu-tour-active .v-step__button-stop {
  border-color: #fe9b44;
  background: #fe9b44;
  color: #ffffff;
}

body.afu-tour-active .v-step__button-next:hover,
body.afu-tour-active .v-step__button-next:focus,
body.afu-tour-active .v-step__button-stop:hover,
body.afu-tour-active .v-step__button-stop:focus {
  border-color: #f08a2e;
  background: #f08a2e;
  color: #ffffff;
}

body.afu-tour-active .v-step__button:focus {
  outline: 2px solid rgba(254, 155, 68, 0.45);
  outline-offset: 2px;
}

body.afu-tour-active .v-step__arrow,
body.afu-tour-active .v-step__arrow::before {
  background: #ffffff;
}

.afu-tour-card {
  position: relative;
}

.afu-tour-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.afu-tour-kicker {
  color: #a07147;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.afu-tour-beta {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  background: #fff1e5;
  color: #d97a18;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.45px;
}

.afu-tour-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: #fff1e5;
  color: #d97a18;
  font-size: 17px;
}

.afu-tour-card h4 {
  margin: 0 0 7px;
  color: #2d3748;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

.afu-tour-card p {
  margin: 0 0 12px;
  color: #5f6b7a;
  font-size: 13px;
  line-height: 1.6;
}

.afu-tour-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 12px;
  padding: 8px 10px;
  border-left: 3px solid #fe9b44;
  border-radius: 0 7px 7px 0;
  background: #f8fafc;
  color: #718096;
  font-size: 11px;
  line-height: 1.5;
}

.afu-tour-note i {
  margin-top: 2px;
  color: #fe9b44;
}

.afu-tour-progress {
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f3f5;
}

.afu-tour-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #fe9b44;
  transition: width 0.25s ease;
}

@media (max-width: 575.98px) {
  body.afu-tour-active .v-step {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
  }

  body.afu-tour-active .v-step__content {
    padding: 16px 16px 10px;
  }

  body.afu-tour-active .v-step__buttons {
    flex-wrap: wrap;
    padding: 0 16px 14px;
  }

  body.afu-tour-active .v-step__button {
    min-height: 40px;
    padding: 9px 12px;
  }

  .afu-tour-card h4 {
    font-size: 16px;
  }

  .afu-tour-card p {
    font-size: 12.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/autoFollowUp/list.vue